import React, { useEffect, useState } from "react";
import fitty from "fitty";
import {
  UserInfoContainer,
  ActionsRow,
  LocationRow,
  UserName,
  ProfilePictureWrapper,
  ProfilePicture,
  Icon,
  IconWrapper,
  Url
} from "./styles";
import User from "containers/user";

import { Col } from "components/shared/layout";
import Badge from "components/badge";
import useWindowSize from "hooks/windowSize";
import { thousandsSeparator } from "utils/regex";
import countries from "constants/countries";
import { Subscribe, Provider } from "unstated";
import { navigate, Link } from "@reach/router";
import routes from "utils/absoluteRoutes";
import { Formik } from "formik";
import Modal, { ModalContext, ModalContent } from "components/modal";
import ImageUpload from "components/image-upload";
import user from "containers/user";
import api from "api";
import { base64ToFormData } from "utils/fileHelper";
import colours from "assets/colours";
import _ from 'lodash';
import mapValuesAsync from 'utils/mapValuesAsync';
import microtasks from "utils/microtaskMap";

const UploadProfilePic = ({ showModal, setShowModal }) => {
  async function onSubmit(values) {
    const formData = await base64ToFormData(
      values.photo,
      `${user.state.id}_profile_picture`,
      "Photo"
    );

    // TODO: send this to Zlto update photo
    await api.users.photo
      .create(user.state.id, formData)
      .then(async (response) => {
        await user.set({ ...response.data });
        setShowModal(false);
      });
  }

  return (
    <Formik onSubmit={onSubmit} initialValues={{ photo: null }}>
      {({ handleSubmit }) =>
        showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <ModalContent>
              <ModalContext.Consumer>
                {({ closeModal }) => (
                  <ImageUpload
                    onSubmit={handleSubmit}
                    name="photo"
                    closeModal={closeModal}
                  />
                )}
              </ModalContext.Consumer>
            </ModalContent>
          </Modal>
        ) : null
      }
    </Formik>
  );
};

const UserInformation = () => {
  const width = useWindowSize()[0];
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [taskStatuses, setTaskStatuses] = useState({});
  const [level, setLevel] = useState(1);

  async function getData(){
    await api.business.get(user.state.profile?.parent_partner_id, user.state.profile?.partner_id, user.state.profile?.my_uuid_id).on('value', snapshot => {
      const data = snapshot.val();
        setData(data.business_requirements.business_information)
        console.log("@@@data.business_requirements@, ", data.business_requirements.business_information)
    });
  };

  async function getTaskStatuses() {
    const statuses = await mapValuesAsync(microtasks, async opportunity_id => {
      try {
        const res = await api.tasks.check(opportunity_id);
        return res;
      } catch(e) {

        return {}
      }
    });
    setTaskStatuses(statuses);
  };
  
  useEffect(() => { 
    getTaskStatuses();

    getData();

    setTimeout(() => {
      fitty("#username", {
        minSize: 12,
        maxSize: 24,
      });
    }, 200);
  }, [width]);

  return (
    <Provider>
      <Subscribe to={[User]}>
        {(user) => (
          <UserInfoContainer>
            <ActionsRow>
              <Icon
                src={require("assets/images/gear-icon-white.svg")}
                alt="Settings icon"
                onClick={() => navigate(routes.settings)}
              />
            </ActionsRow>
            <Col
              style={{ minHeight: "177px" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <ProfilePictureWrapper>
                {user.state?.profile?.profile_picture ? (
                  <Link to={routes.settings}>
                    <ProfilePicture src={user.state.profile.profile_picture} />
                  </Link>
                ) : (
                  <ProfilePicture
                    src={require("assets/images/profile-image-placeholder.svg")}
                    alt="Profile picture"
                  />
                )}
                {!user.state?.profile?.profile_picture && (
                  <IconWrapper>
                    <Icon
                      onClick={() => setShowModal(true)}
                      src={require("assets/images/plus-icon.svg")}
                      alt="Plus"
                    />
                  </IconWrapper>
                )}
              </ProfilePictureWrapper>

              <UploadProfilePic
                showModal={showModal}
                setShowModal={setShowModal}
              />

              <UserName id="username">{`${user.state?.profile?.name} ${user.state?.profile?.surname}` || ""}</UserName>
              <LocationRow>
                <Icon
                  src={require("assets/images/location-pin-icon.svg")}
                  alt="Location icon"
                />
                {user.state?.location_details?.location_province}
                {', '}
                {countries.find((c) => c.code === user.state?.location_details?.location_country)
                  ?.name || ""}
              </LocationRow>
              <LocationRow onClick={ () => navigate(`/biz-profile/business-information/add`, { state: { data, taskStatuses, level } })}>
                {data.trading_name?.value ? (
                  <Url>{data.trading_name?.value}</Url>
                  ) : (
                    <Url>Add Business Details</Url>
                  )}
              </LocationRow>
              <Badge variant="zltoDarkBlueSecondary" style={{ marginBottom: "50px", color: colours.zltoLightBlue }}>
                <Icon
                  style={{ marginRight: 8 }}
                  src={require("assets/images/zlto_logo_white_small.svg")}
                  alt="ZLTO Logo"
                />
                {thousandsSeparator(user.state?.bank_account?.balance_amount || 0)} ZLTO
              </Badge>
            </Col>
          </UserInfoContainer>
        )}
      </Subscribe>
    </Provider>
  );
};

export default UserInformation;
